export const httpStatus = {
  'BAD_REQUEST': 400,
  'FORBIDDEN': 403,
  'INTERNAL_SERVER_ERROR': 500,
  'MOVED_PERMANENTLY': 301,
  'NOT_FOUND': 404,
  'NO_CONTENT': 204,
  'OK': 200,
  'UNAUTHORIZED': 401,
  'UNPROCESSABLE_ENTITY': 422
}

export const textoModalErro = {
  [ httpStatus.INTERNAL_SERVER_ERROR ]: {
    'descricao': 'Ocorreu um erro de conexão. Por favor, verifique seu dados e tente novamente.',
    'titulo': 'Erro de conexão'
  },
  [ httpStatus.NOT_FOUND ]: {
    'descricao': 'A requisição solicitada não foi encontrada. Tente novamente mais tarde.',
    'titulo': 'Requisição não encontrada'
  },
  [ httpStatus.BAD_REQUEST ]: {
    'descricao': 'Houve um problema com os dados da requisição solicitada. Por favor, tente novamente.',
    'titulo': 'Erro nos dados de requisição.'
  },
}

export const TITULO_ERRO_REQUISICAO_GENERALIZADO = 'Ops. Ocorreu um erro!'
